import { teamRoles } from "../../../../../constants/teamRoles";

import getOfferProductionTeamMembersByRole from "../getOfferProductionTeamMembersByRole";

export default function getOfferProductionManagers({ offer }) {
	return getOfferProductionTeamMembersByRole({ offer, role: teamRoles.MANAGER });
}
